export default __webpack_public_path__ + "static/media/modal-lista-disenador-vacio.4eabb8f8.svg";